"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FunnelType = void 0;
const tslib_1 = require("tslib");
const base_models_1 = require("@integration/base-models");
const offerstore_api_models_1 = require("@integration/offerstore-api-models");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const OfferRequest_1 = tslib_1.__importDefault(require("../OfferRequest"));
var FunnelType;
(function (FunnelType) {
    FunnelType["ACQUISITION"] = "acquisition";
    FunnelType["RETENTION"] = "retention";
    // Deprecated, only here to maintain backwards compatability
    FunnelType["RETENTIONN"] = "RETENTION";
})(FunnelType = exports.FunnelType || (exports.FunnelType = {}));
class GetOfferWithEstimatesRequest extends OfferRequest_1.default {
    constructor() {
        super(...arguments);
        this.maxOffers = 3;
    }
}
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsUUID)(),
    (0, base_models_1.Docs)({
        example: '4db7554c-e5cc-4c31-82b0-8bc7d134c0f7',
        description: 'Profile ID as retrieved from the Identification Service. Required when retrieving retention offers but can be omitted if retrieving acquisition offers.',
    }),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.SNAKE_CASE),
    tslib_1.__metadata("design:type", String)
], GetOfferWithEstimatesRequest.prototype, "profileId", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsIn)(Object.values(FunnelType)),
    (0, base_models_1.Docs)({
        example: 'acquisition',
        description: `Funnel type for the returned offers, can be either 'acquisition' or 'retention'`,
        defaultValue: FunnelType.RETENTION,
    }),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.SNAKE_CASE),
    tslib_1.__metadata("design:type", String)
], GetOfferWithEstimatesRequest.prototype, "funnelType", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsIn)(Object.values(offerstore_api_models_1.Channel)),
    (0, base_models_1.Docs)({
        example: offerstore_api_models_1.Channel.MIJN,
        description: `Should be left empty since channel is now read from the api key.`,
    }),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.SNAKE_CASE),
    tslib_1.__metadata("design:type", String)
], GetOfferWithEstimatesRequest.prototype, "channel", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, base_models_1.MultiValue)(),
    (0, class_validator_1.IsIn)(Object.values(base_models_1.DurationInYears), { each: true }),
    (0, base_models_1.Docs)({
        example: [base_models_1.DurationInYears.FLEX, base_models_1.DurationInYears.ONE],
        description: `Filter for which contract duration you want the offers.
If it is left empty, it will fetch contract with all the possible durations.`,
    }),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.SNAKE_CASE),
    tslib_1.__metadata("design:type", Array)
], GetOfferWithEstimatesRequest.prototype, "durations", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)({ maxDecimalPlaces: 0 }),
    (0, class_validator_1.Min)(1),
    (0, class_validator_1.Max)(5),
    (0, class_transformer_1.Type)(() => Number),
    (0, base_models_1.Docs)({
        example: 2,
        description: 'The max number of offers that should be returned. Defaults to maximum of three.',
    }),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.SNAKE_CASE),
    tslib_1.__metadata("design:type", Number)
], GetOfferWithEstimatesRequest.prototype, "maxOffers", void 0);
exports.default = GetOfferWithEstimatesRequest;
